var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopLingkaran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 439,
    viewBox: "0 0 447 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 353.999,
    cy: 85,
    r: 135.769,
    stroke: "#304258",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 85,
    r: 244.385,
    stroke: "#304258",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 85,
    r: 353,
    stroke: "url(#paint0_linear_154_3)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_3",
    x1: 354,
    y1: -268,
    x2: 354,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#304258",
    stopOpacity: 0.830208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304258",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLingkaran);
export default __webpack_public_path__ + "static/media/desktopLingkaran.0c5fc93587e5bff2efd4100cbd6c068a.svg";
export { ForwardRef as ReactComponent };